import { render, staticRenderFns } from "./AccreditationOrganisations.vue?vue&type=template&id=34bd0234&scoped=true&"
import script from "./AccreditationOrganisations.vue?vue&type=script&lang=js&"
export * from "./AccreditationOrganisations.vue?vue&type=script&lang=js&"
import style0 from "./AccreditationOrganisations.vue?vue&type=style&index=0&id=34bd0234&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bd0234",
  null
  
)

export default component.exports